import { createStore } from 'vuex'
import { notificacionService } from '@/_services/index.api'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    toasts: [],
    toastsHistory: [],
    isNewToasts: false,
    isRenderSideBar: true,
    offcanvasVisible: false,
    selectedCustomer: null,
  },
  getters: {
    getToastsCount(state) {
      return state.toasts.length
    },
    getToastsHistory(state) {
      return state.toastsHistory
    },
    isNewToasts(state) {
      return state.isNewToasts
    },
    isRenderSideBar(state) {
      return state.isRenderSideBar
    },
    isOffcanvasVisible(state) {
      return state.offcanvasVisible
    },
    getSelectedCustomer(state) {
      return state.selectedCustomer
    },
  },
  mutations: {
    renderSidebar(state, payload) {
      state.isRenderSideBar = payload
    },
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setToasts(state, payload) {
      const toastWithId = {
        id: payload.id || Math.random().toString(36).substring(2, 9),
        ...payload,
      }
      state.toasts.push(toastWithId)
      state.isNewToasts = true
      console.log('setToasts called with payload', toastWithId)
    },
    removeToast(state, toastId) {
      state.toasts = state.toasts.filter(t => t.id !== toastId)
    },
    updateIsNewToast(state, payload) {
      state.isNewToasts = payload
    },
    resetToast(state) {
      state.toasts = []
    },
    setToastsHistory(state, toastsHistory) {
      state.toastsHistory = toastsHistory
    },
    removeToastFromHistory(state, toastId) {
      state.toastsHistory = state.toastsHistory.filter(t => t.id !== toastId)
    },
    setOffcanvasVisible(state, visible) {
      state.offcanvasVisible = visible
    },
    setSelectedCustomer(state, customer) {
      state.selectedCustomer = customer
    },
  },
  actions: {
    async addToasts(context, payload) {
      console.log('addToasts called with payload', payload)
      context.commit('setToasts', payload)

      let currentUser = JSON.parse(localStorage.currentUser)
      if (currentUser.idUsuario) {
        await notificacionService.insertOrUpdate({
          idUsuario: currentUser.idUsuario,
          titulo: payload.title,
          contenido: payload.content,
          url: payload.url ? payload.content : '',
        })
      }

      context.dispatch('firsLoadToast')
    },
    async firsLoadToast(context) {
      let currentUser = JSON.parse(localStorage.currentUser)
      const response = await notificacionService.getAllByIdUsuario(currentUser.idUsuario, 15)
      if (response.status === 200) {
        context.commit('setToastsHistory', response.data)
      }
    },
  },
  modules: {},
})
